import React, { memo, useCallback, useRef, useState } from 'react';
import { useLang } from '../../util/lang';
import { useDispatch } from 'react-redux';
import { Grid, TextField, FormControlLabel, Checkbox, makeStyles, Box, Typography, Button } from '@material-ui/core';
import style from './../NewPatient/Photos/NewPatientPhotos.module.css';
import { NewPatientPhoto } from '../NewPatient/Photos/NewPatientPhoto';
import Zip from 'jszip';
import { safeGetWithProgress } from '../../axios-default';
import { easySnackbar } from '../../store/Noti/noti.actions';
import FileSaver from 'file-saver';
import { ApiServerUrl } from '../../config.json';
import PercentageProgressRing from '../PercentageProgressRing';
import { getSaveZipFileOption } from '../../util/function';
import { CaseImpressionFileType } from '../../pages/DiffRetainer/modal/type';

const TabPanel = ({ children, value, index, ...other }) => (
    <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
    >
        {value === index && <Box p={3}>{children}</Box>}
    </Typography>
);
const ImpressionViewerStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    input: {
        color: 'black',
    },
}));

/** Renders an existing impression without allowing file changes. */
const ImpressionViewer = (props) => {
    const { caseImpression = {}, hideBiteTwo = false } = props;
    const {
        type,
        scanner_brand,
        doctor_id,
        modern_code,
        waybill_number,
        courier_company,
        stl_file0,
        stl_file1,
        stl_file2,
        stl_file3,
        stl_files_later,
        case_id,
    } = caseImpression;
    const classes = ImpressionViewerStyles(),
        get = useLang('NewPatient');
    const getDiffRetainerLang = useLang('DiffRetainer');
    const normalizedType = (() => {
        const impressionType = String(type || '').toUpperCase();
        if (Object.values(CaseImpressionFileType).includes(impressionType)) return impressionType;
        if (modern_code || waybill_number || courier_company) return CaseImpressionFileType.COURIER;
        if (scanner_brand || doctor_id) return CaseImpressionFileType.SCANNER;
        return CaseImpressionFileType.FILE;
    })();

    if (
        [
            CaseImpressionFileType.LATEST_APPROVED_TREATMENT_PLAN,
            CaseImpressionFileType.LATEST_RETAINER_REQUEST,
        ].includes(normalizedType)
    ) {
        const text =
            normalizedType === CaseImpressionFileType.LATEST_APPROVED_TREATMENT_PLAN
                ? 'lastStepOfLatestApprovedTreatmentPlan'
                : 'useLastRetainerRequestImpressions';
        return (
            <div className={[classes.root, 'tabContainer'].join(' ')}>
                <h2>{getDiffRetainerLang(`readOnlyPrescription.${text}`)}​</h2>
                <h4>{getDiffRetainerLang('readOnlyPrescription.referToDocument')}</h4>
            </div>
        );
    }

    return (
        <div className={[classes.root, 'tabContainer'].join(' ')}>
            {/* <div className={style.headerWrapper}>
        <AppBar position="static">

          <Tabs
            variant="fullWidth"
            value={type}
            aria-label="nav tabs"
            className="inkBar"
            style={{height: 0}}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#593687"
              }
            }}
          >
            <LinkTab style={{ display: type === 'FILE'? null : 'none' }} label='' {...a11yProps(0)} />
            <LinkTab style={{ display: type === 'COURIER'? null : 'none' }} label='' {...a11yProps(1)} />
            <LinkTab style={{ display: type === 'SCANNER'? null : 'none' }} label='' {...a11yProps(2)} />
          </Tabs>

        </AppBar>
      </div> */}
            <TabPanel value={normalizedType} index="FILE">
                <ul className={style.patientImages}>
                    <StlImpression
                        {...{ case_id, stl_file0, stl_file1, stl_file2, stl_file3, stl_files_later, hideBiteTwo }}
                    />
                </ul>
            </TabPanel>
            <TabPanel value={normalizedType} index="COURIER">
                <TextField
                    id="outlined-basic"
                    // disabled={true}
                    label={get('impressions.byCourierLabel')}
                    variant="outlined"
                    inputProps={{
                        className: classes.input,
                    }}
                    style={{ width: '100%', color: 'black' }}
                    value={modern_code || ''}
                />
                <Grid container spacing={1} style={{ marginTop: 16 }}>
                    <Grid item xs={12} md={6} ld={4}>
                        <TextField
                            id="outlined-basic"
                            label={
                                get('impressions.waybillNumber') == 'N/A'
                                    ? 'Waybill Number'
                                    : get('impressions.wayBillNumber')
                            }
                            variant="outlined"
                            value={waybill_number || ''}
                            inputProps={{
                                className: classes.input,
                            }}
                            style={{ width: '100%', color: 'black' }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} ld={4}>
                        <TextField
                            id="outlined-basic"
                            label={
                                get('impressions.courierCompany') != 'N/A'
                                    ? get('impressions.courierCompany')
                                    : 'Courier Company'
                            }
                            variant="outlined"
                            value={courier_company || ''}
                            inputProps={{
                                className: classes.input,
                            }}
                            style={{ width: '100%', color: 'black' }}
                        />
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={normalizedType} index="SCANNER">
                <Grid container spacing={1}>
                    <Grid item xs={12} md={6} ld={4}>
                        <TextField
                            id="outlined-basic"
                            // disabled={true}
                            label={get('impressions.byScannerBrandLabel')}
                            variant="outlined"
                            value={scanner_brand}
                            inputProps={{
                                className: classes.input,
                            }}
                            style={{ width: '100%', color: 'black' }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} style={{ marginTop: 16 }}>
                    <Grid item xs={12} md={6} ld={4}>
                        <TextField
                            id="outlined-basic"
                            // disabled={true}
                            label={get('impressions.byScannerUserNameLabel')}
                            variant="outlined"
                            value={doctor_id}
                            inputProps={{
                                className: classes.input,
                            }}
                            style={{ width: '100%' }}
                        />
                    </Grid>
                </Grid>
            </TabPanel>
        </div>
    );
};
export default ImpressionViewer;

const StlFileMapper = {
    stl_file0: 'Upper STL',
    stl_file1: 'Lower STL',
    stl_file2: 'Bite 1 STL',
    stl_file3: 'Bite 2 STL',
};

const hasStlFile = (file) => typeof file === 'string' && file.trim() !== '';

/** Renders downloadable STL slots for a read-only impression. */
const StlImpression = memo(({ stl_file0, stl_file1, stl_file2, stl_file3, stl_files_later, case_id, hideBiteTwo }) => {
    const get = useLang('NewPatient'),
        dispatch = useDispatch();

    const [downloading, setDownloading] = useState(false),
        progressBarRef = useRef(null);

    const mode = 'view';

    const download = useCallback(async () => {
        try {
            setDownloading(true);
            const zipFile = new Zip();
            const stlFiles = [
                { key: 'stl_file0', file: stl_file0 },
                { key: 'stl_file1', file: stl_file1 },
                { key: 'stl_file2', file: stl_file2 },
                { key: 'stl_file3', file: stl_file3 },
            ].filter(({ file }) => hasStlFile(file));

            if (!stlFiles.length) {
                throw new Error('Cannot get STL files');
            }

            let loaded = [],
                total = [];
            const promises = await Promise.allSettled(
                stlFiles.map(({ file }, i) =>
                    safeGetWithProgress(
                        { baseURL: ApiServerUrl, url: file, responseType: 'blob' },
                        ({ loaded: _loaded, total: _total }) => {
                            loaded[i] = _loaded;
                            total[i] = _total;
                            progressBarRef.current.onProgressChange({
                                loaded: loaded.reduce((a, v) => a + v, 0),
                                total: total.reduce((a, v) => a + v, 0),
                            });
                        }
                    )
                )
            );
            if (promises.some(({ status }) => status !== 'fulfilled')) {
                const failedRequest = promises.map((v, i) => [i, v]).filter(([_, v]) => v.status !== 'fulfilled');
                if (failedRequest.length === stlFiles.length) {
                    await dispatch(easySnackbar(`Cannot get all STL files`, 'error'));
                } else {
                    await dispatch(
                        easySnackbar(
                            `Cannot get ${failedRequest.map(([i]) => StlFileMapper[stlFiles[i].key]).join(', ')}`,
                            'error'
                        )
                    );
                }
                return;
            } else {
                promises.forEach(({ value }, i) => {
                    const filePath = stlFiles[i].file;
                    const extension = /(?:\.([^.]+))?$/.exec(filePath)?.[1];
                    const downloadName = extension
                        ? `${StlFileMapper[stlFiles[i].key]}.${extension}`
                        : StlFileMapper[stlFiles[i].key];
                    zipFile.file(downloadName, value);
                });
            }
            const options = getSaveZipFileOption({ type: 'blob' });
            FileSaver.saveAs(await zipFile.generateAsync(options), `Impression_${case_id}.zip`);
        } catch (err) {
            await dispatch(easySnackbar(err.message || 'Cannot get STL files', 'error'));
        } finally {
            setDownloading(false);
        }
    }, [case_id, dispatch, stl_file0, stl_file1, stl_file2, stl_file3]);

    return (
        <Grid container spacing={1}>
            <PercentageProgressRing ref={progressBarRef} open={downloading} />
            <Grid item xs={12} sm={12}>
                {!stl_files_later && (
                    <Button onClick={download} disabled={downloading} variant="outlined">
                        Download
                    </Button>
                )}
            </Grid>
            <Grid item xs={12} sm={3}>
                <li>
                    <NewPatientPhoto
                        mode={mode}
                        imageId="impression_upper"
                        imageUploaded={hasStlFile(stl_file0)}
                        imageData={hasStlFile(stl_file0) ? stl_file0 : null}
                        imageName={hasStlFile(stl_file0) ? 'uploaded.png' : 'imageUpload.png'}
                        type="impression"
                        //label="STL"
                        StlLabel="Upper STL"
                        StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                        upload_without_STLfile={stl_files_later}
                        // handleRoatate={(degree) => { props.handleRoatate("impression_upper", degree) }}
                        // handleChange={(file) => props.handleChange("impression_upper", file)}
                    />
                </li>
            </Grid>
            <Grid item xs={12} sm={3}>
                <li>
                    <NewPatientPhoto
                        mode={mode}
                        imageId="impression_lower"
                        imageUploaded={hasStlFile(stl_file1)}
                        imageData={hasStlFile(stl_file1) ? stl_file1 : null}
                        imageName={hasStlFile(stl_file1) ? 'uploaded.png' : 'imageUpload.png'}
                        type="impression"
                        //label="STL"
                        StlLabel="Lower STL"
                        StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                        upload_without_STLfile={stl_files_later}
                        // handleRoatate={(degree) => { props.handleRoatate("impression_lower", degree) }}
                        // handleChange={(file) => { props.handleChange("impression_lower", file) }}
                    />
                </li>
            </Grid>

            <Grid item xs={12} sm={3}>
                <li>
                    <NewPatientPhoto
                        mode={mode}
                        imageId="impression_scan_one"
                        imageUploaded={hasStlFile(stl_file2)}
                        imageData={hasStlFile(stl_file2) ? stl_file2 : null}
                        imageName={hasStlFile(stl_file2) ? 'uploaded.png' : 'imageUpload.png'}
                        type="impression"
                        //label="STL"
                        StlLabel="Bite 1 STL"
                        StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                        upload_without_STLfile={stl_files_later}
                        // handleRoatate={(degree) => { props.handleRoatate("impression_scan_one", degree) }}
                        // handleChange={(file) => { props.handleChange("impression_scan_one", file) }}
                    />
                </li>
            </Grid>
            {!hideBiteTwo && (
                <Grid item xs={12} sm={3}>
                    <li>
                        <NewPatientPhoto
                            mode={mode}
                            imageId="impression_scan_two"
                            imageUploaded={hasStlFile(stl_file3)}
                            imageData={hasStlFile(stl_file3) ? stl_file3 : null}
                            imageName={hasStlFile(stl_file3) ? 'uploaded.png' : 'imageUpload.png'}
                            type="impression"
                            StlLabel="Bite 2 STL"
                            StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                            upload_without_STLfile={stl_files_later}
                        />
                    </li>
                </Grid>
            )}

            {stl_files_later && (
                <>
                    <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '8px' }}>
                        <FormControlLabel
                            disabled
                            value="end"
                            control={<Checkbox checked={stl_files_later} />}
                            label={get('impressions.uploadStlFilesLater')}
                            labelPlacement="end"
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
});
